module.exports = __webpack_public_path__ + "static/turquia-015.thumb-bd715fe562c4d51c1ecfc8098f3c9f58.jpg";